<template>
  <el-dialog
      v-el-drag-dialog
      append-to-body
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="打印电抗铭牌"
      class="materialCodeModal"
      width="700px"
      top="5vh">
    <!--    60*30-->
    <div id="labelSettings">
      <el-form :inline="true" label-width="90px">
        <el-form-item label="表头">
          <el-input v-model="titleName"/>
        </el-form-item>
        <el-form-item label="LOGO">
          <el-checkbox v-model="logoVisible"/>
        </el-form-item>
        <el-form-item label="规格型号">
          <el-input v-model="printType"/>
        </el-form-item>
        <el-form-item label="DATE">
          <el-input v-model="printDate"/>
        </el-form-item>
        <el-form-item label="In">
          <el-input v-model="printL1"/>
        </el-form-item>
        <el-form-item label="LN">
          <el-input v-model="printL2"/>
        </el-form-item>
        <el-form-item label="AC">
          <el-input v-model="printAC"/>
        </el-form-item>
        <el-form-item label="Hz">
          <el-input v-model="printHz"/>
        </el-form-item>
        <el-form-item label="Class">
          <el-input v-model="printClass"/>
        </el-form-item>
        <el-form-item label="条码">
          <el-input v-model="barCodeText" @input="codeChange"/>
        </el-form-item>

      </el-form>
    </div>
    <el-divider/>
    <div id="printMaterialBoxLabel6a3">
      <img style="width: 20px;height: 100px;" v-if="logoVisible" :src="logoSrc">
      <div style="flex: 1;margin: 4px 5px 0px 5px;text-align: center;">
        <img style="width: 20px;height: 20px;margin-left: 140px;" v-if="logoVisible" :src="logoCeSrc">
        <div style="font-size: 14px;font-weight: bold;margin-top: -25px;" v-if="logoVisible">{{titleName}}</div>
        <div style="font-size: 14px;font-weight: bold;" v-else>{{titleName}}</div>
        <div style="font-size: 11px;font-weight: bold;margin-top: -2px;">{{printType}}</div>
        <div style="display: flex;text-align: center;margin-top: -2px;">
          <div style="font-size: 11px;font-weight: bold;">I</div>
          <div style="font-size: 8px;margin-top: 4px;font-weight: bold;">N</div>
          <div style="font-size: 11px;font-weight: bold;">=</div>
          <div style="font-size: 11px;font-weight: bold;">{{printL1}}</div>
          <div style="font-size: 11px;margin-left: 60px;">L</div>
          <div style="font-size: 8px;margin-top: 4px;font-weight: bold;">N</div>
          <div style="font-size: 11px;font-weight: bold;">=</div>
          <div style="font-size: 11px;font-weight: bold;">{{printL2}}</div>
        </div>
        <div style="display: flex;margin-top: -2px;">
          <div style="font-size: 11px;font-weight: bold;">{{printAC}}</div>
          <div style="font-size: 11px;margin-left: 10px;font-weight: bold;">{{printHz}}</div>
          <div style="font-size: 11px;margin-left: 15px;font-weight: bold;">{{printClass}}</div>
        </div>
        <div style="display: flex;margin-top: -2px;">
          <div style="font-size: 11px;font-weight: bold;">PD:</div>
          <div style="font-size: 11px;font-weight: bold;">{{printDate}}</div>
        </div>
        <div style="display: flex;">
          <div style="font-size: 12px;font-weight: bold;width: 30px;">S/N:</div>
          <img style="max-width:160px;height:16px;margin-left: 2px;" :id="(() => 'barCode6a3_'+productInfo.pkid)()">
        </div>
        <div style="font-size: 14px;font-weight: bold;margin-top: -5px;text-align: right;">
          Made In China
        </div>
      </div>

    </div>
    <span slot="footer">
      <el-button @click="dialogVisible = false">关闭</el-button>
      <el-button type="primary" v-print="printOption" @click="print">打印</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import JsBarcode from "jsbarcode";
  import moment from "moment";

  export default {
    data() {
      return {
        dialogVisible: false,
        titleName: "Tuning Reactor",
        logoVisible: true,
        printType: "",
        printDate: "",
        printName: "",
        printL1: "",
        printPIn: "I",
        printL2: "",
        printUL: "∆U:",
        printAC: "",
        printHz: "",
        printClass: "",
        productInfo: {},
        logoSrc: "",
        logoCeSrc: "",
        madeInChinaSrc: "",
        barCodeText: "",
        printOption: {
          id: "printMaterialBoxLabel6a3",
          preview: false,
          popTitle: "打印",
          previewPrintBtnLabel: "打印",
          clickMounted() {
          },
        },
      };
    },

    methods: {
      open(productInfo) {
        // this.logoSrc = "../../../../img/se/print_logo.png";
        this.logoSrc = "../../../../img/se/logo_rol2.png";
        this.logoCeSrc = "../../../../img/se/ce.jpg";
        this.madeInChinaSrc = "../../../../img/se/madeInChina1.png";
        this.dialogVisible = true;
        this.productInfo = productInfo;

        this.printType = this.productInfo.specification;
        if (this.printType) {
          let params = this.printType.split("-");
          if (params.length >= 3) {
            if (params[0] == "ATR") {
              this.printL1 = parseInt(params[1]) + "A";
              this.printL2 = parseFloat(params[2].replace("M", ".")) + "mH";
              this.printAC = "AC 400V";
              this.printHz = "50-60Hz";
              this.printClass = "class:F";
            }

          }
        }

        this.printName = this.productInfo.materialName;
        this.printDate = this.productInfo.planFinishTime;
        // this.barCodeText = moment(new Date()).format("YYYYMMDD");
        this.barCodeText = moment(new Date(this.printDate)).format("YYYYMMDD");

        this.$nextTick(() => {
          document.getElementById("barCode6a3_" + this.productInfo.pkid).innerHTML = "";
          this.bindBarCode(this.barCodeText, this.productInfo.pkid);
        });
      },
      bindBarCode(row, id) {
        let text = row;
        new JsBarcode(document.getElementById("barCode6a3_" + id), row, {
          text: text,
          fontSize: 14,
          width: 4,
          height: 8,
          margin: 0,
          displayValue: false,
        });
      },
      codeChange() {
        // this.$nextTick(() => {
        document.getElementById("barCode6a3_" + this.productInfo.pkid).innerHTML = "";
        this.bindBarCode(this.barCodeText, this.productInfo.pkid);
        // });
      },

      print() {
      },
    },
  };
</script>
<style lang="scss" scoped>
.materialCodeModal .el-dialog__header {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 99999;
  box-sizing: border-box;
}

.materialCodeModal .el-dialog__footer {
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 99999;
  box-sizing: border-box;
  background-color: #fff;
}

.materialCodeModal .el-dialog {
  margin: 2% auto !important;
  transform: scale3d(1, 1, 1);
  padding-top: 30px;
  padding-bottom: 39px;
  height: 90%;
}

.materialCodeModal .el-divider--horizontal {
  margin: 10px 0;
}

.materialCodeModal .el-dialog .el-dialog__body {
  height: 100%;
  background-color: #fff;
  overflow: scroll;
}
</style>

<style lang="scss" scoped>
#printMaterialBoxLabel6a3 {
  width: 59mm;
  height: 29mm;
  margin: 0 auto;
  //margin-top: 1mm;
  page-break-before: always;
  font-size: 10px;
  display: flex;
  align-items: center;
}
</style>
